var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"offset-10 col-2 head-buttons-block"},[_c('router-link',{staticClass:"login-btn",attrs:{"to":{ name: 'auth'}}},[_c('div',{staticClass:"enter-logo"}),_c('span',[_vm._v("Войти")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f150ee6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/set_local_token.vue
// module id = null
// module chunks = 